import SourceDataDetails, { ISourceDataDetailsProps } from "@/components/details/SourceDataDetails";
import { FC } from "react";

interface INoteDetailsProps extends ISourceDataDetailsProps {
}


const NoteDetails: FC<INoteDetailsProps> = (props) => {
    return (
        <SourceDataDetails {...props} />
    )
}

export default NoteDetails;